export default [
  {
    prop: "ResponsableBy",
    name: "Responsable",
    label: "Responsable",
    sortable: false,
    formatter: ({ ResponsableBy }) => ResponsableBy.CreatedByUser.FullName
  },
  {
    prop: "ComplaintAndClaimMovement",
    name: "Acción",
    label: "Acción",
    sortable: false,
    formatter: ({ ComplaintAndClaimMovement }) => {
      if (ComplaintAndClaimMovement.Action === 0) return "Internos";
      if (ComplaintAndClaimMovement.Action === 1) return "Externos";
    }
  },
  {
    prop: "ComplaintAndClaimMovement",
    name: "Comentario",
    label: "Comentario",
    sortable: true,
    formatter: ({ ComplaintAndClaimMovement }) =>
      ComplaintAndClaimMovement.Comments
  },
  {
    prop: "ResponsableBy",
    name: "Responsable",
    label: "Responsable",
    sortable: false,
    formatter: ({ ResponsableBy }) => ResponsableBy.FullName
  }
];
